import React from 'react';
import errorImage from '../../images/404.gif';
const NotFound = () => {
    return (
        <div style={{margin: '0 auto'}} className="">
            <h1 style={{textAlign:'center', color: 'white'}}>Sorry! The Data you are looking for is not available. </h1>
            <img style={{margin: '20px auto', display: 'block'}} src={errorImage} alt=""/>
        </div>
    );
};

export default NotFound;